import type { ForumTopic } from '../services/forumService';
import forumService from '../services/forumService';

/**
 * Bild eines Forum-Themas (PURE, 2026-09-03): Header-Bild > erster Anhang
 * vom Typ image (Thumbnail vor Original) > null. Rohwert, noch nicht aufgelöst.
 */
export function forumTopicImageRaw(topic: Pick<ForumTopic, 'headerImageUrl' | 'media'> | null | undefined): string | null {
  if (!topic) return null;
  const header = typeof topic.headerImageUrl === 'string' ? topic.headerImageUrl.trim() : '';
  if (header) return header;
  const media = Array.isArray(topic.media) ? topic.media : [];
  const img = media.find((m) => m && m.type === 'image' && (m.thumbnailUrl || m.url));
  if (!img) return null;
  const raw = (img.thumbnailUrl || img.url || '').trim();
  return raw || null;
}

/** Aufgelöste, ladbare URL (nutzt den Forum-Service-URL-Builder) */
export function forumTopicImageUrl(topic: Pick<ForumTopic, 'headerImageUrl' | 'media'> | null | undefined): string | null {
  const raw = forumTopicImageRaw(topic);
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) return raw;
  return forumService.buildAvatarUrl(raw) || null;
}

export default forumTopicImageUrl;
